import { Create } from "react-admin";
import { useNotification } from "../../../common/hooks/useNotification";
import { EditActions } from "../../common/form/FormActions";
import { FuelProviderForm } from "./FuelProviderForm";

interface Props {}

export const FuelProviderCreate = (props: Props) => {
  const notify = useNotification(props, "createSuccess");
  return (
    <Create
      {...props}
      actions={<EditActions />}
      onSuccess={notify}
      title="resources.admin-fuel-providers.title.create">
      <FuelProviderForm />
    </Create>
  );
};
